import { lazy, Suspense } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { AppShell } from './components/layout/AppShell';
import { RequireAuth } from './components/RequireAuth';
import { Spinner } from './components/ui/Card';
import { AppDataProvider } from './services/data/AppDataProvider';
import { DashboardScreen } from './features/dashboard/DashboardScreen';
import { ShowsScreen } from './features/shows/ShowsScreen';
import { ShowDetailScreen } from './features/shows/ShowDetailScreen';
import { PracticeScreen } from './features/rehearsal/PracticeScreen';
import { SettingsScreen } from './features/settings/SettingsScreen';
import { DonateScreen } from './features/donate/DonateScreen';

// Rehearsal, import and analytics each pull in heavy dependencies, so they
// stay out of the initial bundle that gates first paint on mobile.
const ImportScreen = lazy(() =>
  import('./features/import/ImportScreen').then((m) => ({ default: m.ImportScreen })),
);
const RehearsalScreen = lazy(() =>
  import('./features/rehearsal/RehearsalScreen').then((m) => ({ default: m.RehearsalScreen })),
);
const ProgressScreen = lazy(() =>
  import('./features/progress/ProgressScreen').then((m) => ({ default: m.ProgressScreen })),
);
const FlashcardsScreen = lazy(() =>
  import('./features/rehearsal/FlashcardsScreen').then((m) => ({ default: m.FlashcardsScreen })),
);
const FeedbackScreen = lazy(() =>
  import('./features/feedback/FeedbackScreen').then((m) => ({ default: m.FeedbackScreen })),
);

export default function App() {
  return (
    <RequireAuth>
      <AppDataProvider>
        <Suspense fallback={<Spinner />}>
          <Routes>
            <Route path="/rehearse/:showId/:mode" element={<RehearsalScreen />} />
            <Route path="/flashcards/:showId" element={<FlashcardsScreen />} />
            <Route element={<AppShell />}>
              <Route index element={<DashboardScreen />} />
              <Route path="shows" element={<ShowsScreen />} />
              <Route path="shows/new" element={<ImportScreen />} />
              <Route path="shows/:showId" element={<ShowDetailScreen />} />
              <Route path="practice" element={<PracticeScreen />} />
              <Route path="practice/:showId" element={<PracticeScreen />} />
              <Route path="progress" element={<ProgressScreen />} />
              <Route path="progress/:showId" element={<ProgressScreen />} />
              <Route path="donate" element={<DonateScreen />} />
              <Route path="settings" element={<SettingsScreen />} />
              <Route path="feedback" element={<FeedbackScreen />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Route>
          </Routes>
        </Suspense>
      </AppDataProvider>
    </RequireAuth>
  );
}
